import { blushColors, eyeshadowColors } from '../../makeuphair/components/services/configs/makeup/cheekEyeshadowColors';
import lipstickConfig from '../../makeuphair/components/services/configs/makeup/lipstick';
import { skinToneColors } from '../../makeuphair/components/services/configs/makeup/skinToneColors';
import { noneLayer, colorLayer, eyelinerLayer, eyelashLayer } from './labMakeupSchema';

export const NONE_OPTION = { id: 'none', label: 'None', layer: noneLayer() };

const toOptions = (colors, finish = {}) =>
  colors.map((c) => ({
    id: c.hex,
    label: c.name,
    layer: colorLayer(c.name, c.hex, finish.defaultIntensity ?? 28, finish),
  }));

export const CUSTOM_CATEGORY_OPTIONS = {
  foundation: [
    NONE_OPTION,
    {
      id: 'auto-skin',
      label: 'Auto (sheer — only if you want base)',
      layer: { ...colorLayer('(from skin analysis)', null, 26, { finishName: 'Sheer', finishType: 'sheer' }), autoSkin: true },
    },
    ...skinToneColors.map((c) => ({
      id: c.hex,
      label: c.name,
      layer: colorLayer(c.name, c.hex, 28, { finishName: 'Satin', finishType: 'satin' }),
    })),
  ],
  concealer: [
    NONE_OPTION,
    {
      id: 'auto-concealer',
      label: 'Auto (one step lighter than foundation)',
      layer: {
        ...colorLayer('(from skin analysis)', null, 20, { finishName: 'Satin', finishType: 'satin' }),
        autoSkinConcealer: true,
      },
    },
    ...skinToneColors.map((c) => ({
      id: c.hex,
      label: c.name,
      layer: colorLayer(c.name, c.hex, 22, { finishName: 'Satin', finishType: 'satin' }),
    })),
  ],
  blush: [
    NONE_OPTION,
    {
      id: 'auto-blush',
      label: 'Auto (from photo flush)',
      layer: {
        ...colorLayer('Auto', null, 28, { finishName: 'Satin', finishType: 'satin' }),
        autoBlush: true,
      },
    },
    ...toOptions(blushColors, { finishName: 'Satin', finishType: 'satin', defaultIntensity: 30 }),
  ],
  eyeshadow: [
    NONE_OPTION,
    {
      id: 'auto-eyeshadow',
      label: 'Auto (from photo / undertone)',
      layer: {
        ...colorLayer('Auto', null, 26, { finishName: 'Matte', finishType: 'matte' }),
        autoEyeshadow: true,
      },
    },
    ...toOptions(eyeshadowColors, { finishName: 'Satin', finishType: 'satin', defaultIntensity: 28 }),
  ],
  eyeliner: [
    NONE_OPTION,
    {
      id: 'minimal',
      label: 'Minimal tightline',
      layer: eyelinerLayer('Minimal Tightline', 'minimal_tightline', 'Espresso Brown', '#3B1F14', 28),
    },
    {
      id: 'soft',
      label: 'Soft smudge brown',
      layer: eyelinerLayer('Soft Smudge', 'soft_smudge', 'Espresso Brown', '#3B1F14', 30),
    },
    {
      id: 'cat_eye',
      label: 'Cat eye',
      layer: eyelinerLayer('Cat Eye', 'cat_eye', 'Jet Black', '#000000', 32),
    },
  ],
  eyelash: [
    NONE_OPTION,
    {
      id: 'natural',
      label: 'Natural',
      layer: eyelashLayer('Natural', 'natural', 'Soft Black', '#2B2B2B', 32),
    },
    {
      id: 'elegant',
      label: 'Elegant',
      layer: eyelashLayer('Elegant', 'elegant', 'Soft Black', '#2B2B2B', 34),
    },
    {
      id: 'soft',
      label: 'Soft flutter',
      layer: eyelashLayer('Soft Flutter', 'soft_flutter', 'Soft Black', '#2B2B2B', 36),
    },
    {
      id: 'cat_eye_lash',
      label: 'Cat eye lash',
      layer: eyelashLayer('Cat Eye Lash', 'cat_eye_lash', 'Jet Black', '#111111', 36),
    },
    {
      id: 'wispy',
      label: 'Wispy',
      layer: eyelashLayer('Wispy', 'wispy', 'Soft Black', '#2B2B2B', 36),
    },
  ],
  lipstick: [
    NONE_OPTION,
    {
      id: 'auto-lip',
      label: 'Auto (harmonized nude)',
      layer: {
        ...colorLayer('Auto', null, 32, { finishName: 'Satin', finishType: 'satin' }),
        autoLip: true,
      },
    },
    ...toOptions(lipstickConfig.colors, { finishName: 'Satin', finishType: 'satin', defaultIntensity: 34 }),
  ],
  highlighter: [
    NONE_OPTION,
    {
      id: '#D4AF37',
      label: 'Gold Sheen',
      layer: colorLayer('Gold Sheen', '#D4AF37', 28, { finishName: 'Shimmer', finishType: 'shimmer' }),
    },
    {
      id: '#F5D0D8',
      label: 'Rose Glow',
      layer: colorLayer('Rose Glow', '#F5D0D8', 30, { finishName: 'Dewy', finishType: 'dewy' }),
    },
  ],
  contour: [NONE_OPTION],
  eyebrows: [
    NONE_OPTION,
    {
      id: 'match',
      label: 'Match guest brow',
      layer: colorLayer('match guest brow', null, 28),
    },
  ],
};
